import React from "react";

import { AspectRatiosDataProvider } from "../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import { FramerateProfilesDataProvider } from "../../common/data/lookup-data-providers/FramerateProfilesDataProvider";
import { ManzanitaPresetDataProvider } from "../../common/data/lookup-data-providers/ManzanitaPresetsDataProvider";
import { HeaderBreadcrumb } from "../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../AdminRoutes";
import { EncodeSpecificationProvider } from "./context/EncodeSpecificationProvider";
import { EncodeSpecificationListing } from "./listing/EncodeSpecificationListing";

export const EncodeSpecificationDashboard: React.FC = () => {
    return (
        <EncodeSpecificationProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <ManzanitaPresetDataProvider>
                <AspectRatiosDataProvider>
                    <FramerateProfilesDataProvider>
                        <EncodeSpecificationListing />
                    </FramerateProfilesDataProvider>
                </AspectRatiosDataProvider>
            </ManzanitaPresetDataProvider>
        </EncodeSpecificationProvider>
    );
};
